import axios from 'axios';
import qs from 'qs';

function addToCart(productId, size) {
  const client = axios.create({
    headers: { 'X-Requested-With': 'XMLHttpRequest' },
  });
  client.defaults.xsrfHeaderName = 'X-CSRFTOKEN';
  client.defaults.xsrfCookieName = 'csrftoken';

  return client.post('/cart/items/add_to_cart/', qs.stringify({
    product_id: productId,
    size,
  }));
}

export default addToCart;
